import styled from 'styled-components'

export const OverflowContainer = styled.div`
  @media (max-width: 768px) {
    overflow-x: auto;
    overflow-y: hidden;
  }
`

export const DataTable = styled.table`
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;

  max-width: 750px;

  border-spacing: 0;
  border-collapse: separate;
  display: table;
  border: 1px solid white;

  @media print {
    break-inside: avoid !important;
    max-width: none;
    width: 100%;
    overflow: visible;
  }

  th,
  td {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    border: 1px solid white;
    padding: 9px;
    font-weight: lighter;
    vertical-align: baseline;

    &.center-text {
      text-align: center;
    }
  }

  th {
    background: #dce0e0;
  }

  thead th {
    vertical-align: bottom;
  }

  @media print {
    thead > tr > th:nth-child(1),
    thead > tr > td:nth-child(1) {
      width: 30%;
    }
  }

  .multi-row {
    border-top-width: 0;
    border-bottom-width: 0;
  }
  .multi-row-start {
    border-bottom-width: 0;
  }
  .multi-row-end {
    border-top-width: 0;
  }

  .multi-col {
    border-left-width: 0;
    border-right-width: 0;
  }
  .multi-col-start {
    border-right-width: 0;
  }
  .multi-col-end {
    border-left-width: 0;
  }
`
